
































import Vue from 'vue';
import Component from 'vue-class-component';
import { Emit, Prop, Watch } from 'vue-property-decorator';
import Project from '../models/Project';
import ProjectServer from '../models/ProjectServer';
import Mutations from '../store/mutations';
import { EllipseCurve } from 'three';
import UserGroup from '../models/UserGroup';
import LtiPaymentPanel from '@/components/payment/LTIPaymentPanel.vue';

@Component({
    components: { LtiPaymentPanel }
})
export default class ReconnectView extends Vue 
{
    get is_reconnecting()
    {
        return this.$route.path.includes("reconnect");
    }

    get pid()
    {
        return this.$route.params.id as string;
    }

    get delay()
    {
        if (!this.$route.params.delay)
        {
            return 0;
        }
        return parseFloat(this.$route.params.delay as string);
    }

    get targetRoute() : string
    {
        if (this.$route.query.targetRoute)
        {
            return this.$route.query.targetRoute as string;
        }
        return "/app/project/timelines";
    }

    get connectionStatus() : string
    {
        if (!(this.requirePayment))
        {
            if (this.checkingAccess)
            {
                return 'Checking project access...';
            }
            return `${ this.is_reconnecting ? "Reconnecting" : "Connecting" } to project...`;
        }
        return "";
    }

    pinfo : Project | null = null;

    connect(pid : string)
    {
        let inst = ProjectServer.instance;
        inst.IsRequestingAddress = true;
        this.$router.push(this.targetRoute);
        this.$http.post(`connect`, { projectId: pid }).then(
            (result) =>
            {
                if (!ProjectServer.isActiveInstance(inst))
                {
                    inst.disconnect();
                    return;
                }

                if (result.data.error != undefined)
                {
                    // if error, do nothing
                    alert(result.data.error);
                    inst.disconnect();
                    this.$router.push("/");
                    return;
                }
                else
                {
                    // otherwise, connect
                    this.$store.commit(Mutations.setProject, this.pinfo);
                    this.$store.dispatch('getProjectSubscription');

                    ProjectServer.host = result.data.ip;
                    ProjectServer.port = result.data.port;
                    
                    const troute = result.data.route;
                    ProjectServer.route = troute == undefined ? null : troute;
                        
                    inst.connectToServer();
                    console.log(Object.assign({}, this.pinfo));
                }
                inst.IsRequestingAddress = false;
            },
            (error) =>
            {
                if (error.response.data.error)
                {
                    alert(`Couldn't connect - ${error.response.data.error}`);
                }
                else
                {
                    alert(`Couldn't connect - ${JSON.stringify(error.response.data)}`);
                }
                inst.disconnect();
                this.$router.push("/");
            }
        );
        
        this.$nextTick(() =>
        {
            const element = document.getElementById("connect-status");
            if (element)
            {
                element.focus();
            }
        });
    }

    is_mounted = false;

    beforeDestroy()
    {
        this.is_mounted = false;
    }

    checkingAccess = false;
    async checkPaymentStatus()
    {
        this.checkingAccess = true;
        try
        {
            await this.$http.get(`payments/lti/status?pid=${this.pid}`);
            return true;
        }
        catch(er)
        {
            console.error(er);
        }
        this.checkingAccess = false;
        return false;
    }

    requirePayment = false;
    async mounted()
    {
        this.is_mounted = true;
        try
        {
            let pinfo_resp = await this.$http.get<{status : string, result : Project}>(`projectinfo/${this.pid}`);
            let prj = Object.assign(new Project, pinfo_resp.data.result);
            this.$set(this, "pinfo", prj);

            let resp = await this.$http.get(`getprojectusergroups?pid=${prj.id}`);
            if (resp.data.error)
            {
                alert(resp.data.error);
                return;
            }
            try
            {
                this.$set(prj, "groups", resp.data.groups);
                this.$set(prj, "group", prj.groups.find((g)=>g.id == resp.data.group));

                let userid = this.user.userid.toLowerCase();
                let data = (await this.$http.get(`viewprojectusers?pid=${prj.id}`)).data;
                if (data.error)
                {
                    this.$set(prj, 'groupError', data.error);
                    //this.$set(prj, 'group', null);
                    this.$forceUpdate();
                }
                
                // Workaround for error
                if (data.users == undefined)
                {
                    data.users = [];
                }
                
                this.$set(prj, "users", data.users);
            }
            catch (ex)
            {
                let resp = ex.response;
                let data = resp.data;
                if (data.error)
                {
                    this.$set(prj, 'groupError', data.error);
                    //this.$set(prj, 'group', null);
                    this.$forceUpdate();
                }

                console.error(ex);
                alert(`Projects.vue: ${ex}`);
            }
        }
        catch(er)
        {
            console.error("Failed to load pinfo, check below for details");
            console.error(er);
            alert("Failed to load project data.  Check javascript console for details.  Redirecting to dashboard.");
            this.$router.push("/");
            return;
        }

        let pid = this.pid;
        if (!(await this.checkPaymentStatus()))
        {
            this.requirePayment = true;
            const element = document.getElementById("pay-panel");
            if (element)
            {
                element.focus();
            }
            return;
        }

        if (this.delay > 0)
        {
            setTimeout(() =>
            {
                if (this.is_mounted)
                {
                    this.connect(pid);
                }
            }, this.delay * 1000);
        }
        else
        {
            this.connect(pid);
        }
    }
}
